import { Api_url } from '../../common/api_url'
import { API_XANO_BASE_URL } from '../../config/api_config'
import { axiosAuth } from '../../config/axiosInstances'
import { SET_OPEN_SUBSCRIPTION_MODAL, SET_USER_SUBSCRIPTION } from './types';

export function getCurrentSubscription(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(
                API_XANO_BASE_URL + Api_url.GetCurrentSubscription,
                {
                    user_id
                }
            );
            dispatch({ type: SET_USER_SUBSCRIPTION, payload: {...response.data , cache_time : Date.now() + 60 * 60 * 1000} })
            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getCurrentSubscriptionWithoutCache(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetCurrentSubscription, { user_id })
            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function setOpenSubscriptionModal(data, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            dispatch({ type: SET_OPEN_SUBSCRIPTION_MODAL, payload: data })

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getLeads({ user_id, product_id, product_type, product_name, user_plan, is_visit }, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.GetLeads, {
                user_id,
                product_id,
                product_type,
                product_name,
                user_plan,
                is_visit
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}
